import { useCallback, useEffect } from "react";

const panelCloseEvent = "template-panel-close";

declare global {
  interface WindowEventMap {
    [panelCloseEvent]: CustomEvent;
  }
}

export function useForceClosePanel() {
  return useCallback(() => {
    window.dispatchEvent(new CustomEvent(panelCloseEvent));
  }, []);
}

export function useWatchForExternalPanelClose(onRequestClose: () => void) {
  useEffect(() => {
    window.addEventListener(panelCloseEvent, onRequestClose);
    return () => {
      window.removeEventListener(panelCloseEvent, onRequestClose);
    };
  }, [onRequestClose]);
}
